import { useEffect, useState } from "react";

import { Badge, Button, Card, CardContent, CardHeader, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Grid, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TableRow, Tooltip, Typography } from "@mui/material";

import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";

import { AiOutlineOrderedList, AiOutlineFileText } from "react-icons/ai";

import moment from "moment";

import { TablePaginationActions } from "../../../helpers/TablePaginationActions";

import { usePages } from "../../../hooks/usePages";

import { TableTheadStyle, TablePaddingStyle } from "../../../styles/TableStyle";

import { Layout } from "../../../components/Layout";

import { DialogDocumento } from "../../../dialogs/DialogDocumento";

import { BuscarListaAcuerdos } from "../../../connections/tribunal/ListaAcuerdoConnection";

import { AcuerdoProps, ListaAcuerdosProps } from "../../../interfaces/tribunal/ListaAcuerdosInterface";

export const ConsultarListaAcuerdosPage = () => {

    const [loading, setLoading] = useState( false );

    const [rows, setRows] = useState<ListaAcuerdosProps[]>( [] );
    const [recordsCount, setRecordsCount] = useState( 0 );

    const [filtroAplicado, setFiltroAplicado] = useState( false );

    const [fechaInicio, setFechaInicio] = useState<moment.Moment | null>( moment() );
    const [fechaFin, setFechaFin] = useState<moment.Moment | null>( moment() );

    const [openAcuerdos, setOpenAcuerdos] = useState( false );
    const [acuerdos, setAcuerdos] = useState<AcuerdoProps[]>( [] );

    const [documento, setDocumento] = useState( '' );
    const [openDocumento, setOpenDocumento] = useState( false );

    const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage, resetPage } = usePages( 10 );
    const { page: pageAcuerdos, rowsPerPage: rowsPerPageAcuerdos, handleChangePage: handleChangePageAcuerdos, handleChangeRowsPerPage: handleChangeRowsPerPageAcuerdos } = usePages( 5 );

    const handleBuscar = () => {

        setFiltroAplicado( true );
        resetPage();

    };

    const handleLimpiar = () => {

        setFiltroAplicado( false );
        setFechaInicio( moment() );
        setFechaFin( moment() );

        setRows( [] );
        setRecordsCount( 0 );
        resetPage();

    };

    useEffect(() => {

        if ( !filtroAplicado || !fechaInicio || !fechaFin ) return;

        setLoading( true );
        setRows( [] );

        BuscarListaAcuerdos({

            fechaInicio: fechaInicio.format('YYYY-MM-DD'), fechaFin: fechaFin.format('YYYY-MM-DD'), page, rowsPerPage

        }).then( response => {

            setTimeout(() => {

                setRows( response.records );
                setRecordsCount( response.recordsCount );
                setLoading( false );

            }, 700);

        });

    }, [ filtroAplicado, page, rowsPerPage, fechaInicio, fechaFin ]);

    return (
        <Layout breadcrumbs={ [{ text: 'Tribunal' }, { text: 'Lista de acuerdos' }, { text: 'Consultar lista de acuerdos' }] } backgroundPaper={ false }>

            <Grid container spacing={ 3 }>

                <Grid size={{ md: 12, xs: 12 }}>

                    <Card>

                        <CardHeader
                            sx={{ backgroundColor: (theme) => theme.palette.primary.main, py: 2 }}
                            subheader={<Typography sx={{ fontSize: 14, fontWeight: 'bold', color: 'white' }}> Filtro(s) </Typography>}
                        />

                        <Divider />

                        <CardContent sx={{ p: 3 }}>

                            <Grid container spacing={ 3 }>

                                <Grid size={{ xs: 12, md: 5 }}>

                                    <LocalizationProvider dateAdapter={ AdapterMoment }>

                                        <DatePicker
                                            label="Fecha de inicio"
                                            sx={{ width: '100%' }}
                                            value={ fechaInicio }
                                            onChange={ (v) => setFechaInicio( v ) }
                                            maxDate={ moment() }
                                            disabled={ filtroAplicado }
                                        />

                                    </LocalizationProvider>

                                </Grid>

                                <Grid size={{ xs: 12, md: 5 }}>

                                    <LocalizationProvider dateAdapter={ AdapterMoment }>

                                        <DatePicker
                                            label="Fecha de finalización"
                                            sx={{ width: '100%' }}
                                            value={ fechaFin }
                                            onChange={ (v) => setFechaFin( v ) }
                                            maxDate={ moment() }
                                            disabled={ filtroAplicado }
                                        />

                                    </LocalizationProvider>

                                </Grid>

                                <Grid size={{ xs: 12, md: 2 }}>

                                    <Button
                                        fullWidth
                                        color={ filtroAplicado ? 'inherit' : 'primary' }
                                        variant='contained'
                                        disabled={ loading || !fechaInicio || !fechaFin }
                                        onClick={ filtroAplicado ? handleLimpiar : handleBuscar }
                                    >
                                        { filtroAplicado ? 'Limpiar' : 'Buscar' }
                                    </Button>

                                </Grid>

                            </Grid>

                        </CardContent>

                    </Card>

                </Grid>

                <Grid size={{ md: 12, xs: 12 }}>

                    <TableContainer sx={{ borderRadius: 3 }} component={ Paper }>

                        <Table>

                            <TableHead sx={{ ...TableTheadStyle }}>

                                <TableRow sx={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>

                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%', fontWeight: 'bold' }}></TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '15%', fontWeight: 'bold' }}>Fecha</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '30%', fontWeight: 'bold' }}>Usuario generó</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '15%', fontWeight: 'bold', textAlign: 'center' }}>Ver acuerdos</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '15%', fontWeight: 'bold', textAlign: 'center' }}>Ver lista de acuerdos</TableCell>

                                </TableRow>

                            </TableHead>

                            <TableBody>

                                {
                                    rows.map( (row, index) => (

                                        <TableRow key={ index }>

                                            <TableCell sx={{ textAlign: 'center' }}>
                                                <Typography variant="subtitle1">
                                                    <strong>{ 'GLA-' + row.idListaAcuerdos }</strong>
                                                </Typography>
                                            </TableCell>

                                            <TableCell>
                                                <Typography variant='subtitle1'>
                                                    { moment( row.fechaGeneracion ).format('DD-MM-YYYY') }
                                                </Typography>
                                                <Typography variant='caption' color='text.secondary'>
                                                    { moment( row.fechaGeneracion ).format('hh:mm a') }
                                                </Typography>
                                            </TableCell>

                                            <TableCell>
                                                <Typography variant='subtitle1' fontSize={ 14 }>{ row.usuarioGenero }</Typography>
                                            </TableCell>

                                            <TableCell sx={{ textAlign: 'center' }}>
                                                <Tooltip title='Visualizar acuerdos'>
                                                    <IconButton color="primary" onClick={ () => { setAcuerdos( row.acuerdos ); setOpenAcuerdos( true ); } }>
                                                        <Badge
                                                            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                                                            badgeContent={<Typography variant="subtitle2">{ row.acuerdos.length }</Typography>}
                                                            color="secondary"
                                                        >
                                                            <AiOutlineOrderedList fontSize={ 28 } />
                                                        </Badge>
                                                    </IconButton>
                                                </Tooltip>
                                            </TableCell>

                                            <TableCell sx={{ textAlign: 'center' }}>
                                                <Tooltip title='Visualizar lista de acuerdos'>
                                                    <IconButton color="primary" onClick={ () => { setDocumento( row.documento ); setOpenDocumento( true ); } }>
                                                        <AiOutlineFileText fontSize={ 28 } />
                                                    </IconButton>
                                                </Tooltip>
                                            </TableCell>

                                        </TableRow>

                                    ))
                                }

                                {
                                    ( recordsCount === 0 && !loading )
                                    ?
                                        <TableRow style={{ height: 100 }}>

                                            <TableCell colSpan={ 5 } align="center">
                                                <Typography variant="caption" color='secondary'> No se encontraron registros </Typography>
                                            </TableCell>

                                        </TableRow>
                                    :
                                        loading
                                        &&
                                            <TableRow style={{ height: 100 }}>

                                                <TableCell colSpan={ 5 } align="center">
                                                    <CircularProgress size={ 26 } />
                                                </TableCell>

                                            </TableRow>
                                }

                            </TableBody>

                            <TableFooter>

                                <TableRow>

                                    <TableCell colSpan={ 2 }>
                                        <Typography variant='body2' color='black' sx={{ fontWeight: 'bold' }}>Total de registros: { recordsCount }</Typography>
                                    </TableCell>

                                    <TablePagination
                                        rowsPerPageOptions={ [ 5, 10, 15, 25, 50, 75, 100, 150, 200, 500 ] }
                                        colSpan={ 8 }
                                        count={ recordsCount }
                                        rowsPerPage={ rowsPerPage }
                                        page={ page }
                                        onPageChange={ handleChangePage }
                                        onRowsPerPageChange={ handleChangeRowsPerPage }
                                        ActionsComponent={ TablePaginationActions }
                                        labelRowsPerPage='Filas por página:'
                                        labelDisplayedRows={ ({ from, to, count }) => `${ from }-${ to } de ${ count }` }
                                    />

                                </TableRow>

                            </TableFooter>

                        </Table>

                    </TableContainer>

                </Grid>

            </Grid>

            <DialogDocumento
                documento={ documento }
                openDialog={ openDocumento }
                handleCloseDialog={ () => setOpenDocumento( false ) }
            />

            <Dialog maxWidth="xl" fullWidth={ true } open={ openAcuerdos } onClose={ () => {} }>

                <DialogTitle>Acuerdo(s)</DialogTitle>

                <DialogContent>

                    <Grid container spacing={ 3 }>

                        <Grid size={{ md: 12, xs: 12 }}>

                            <TableContainer sx={{ borderRadius: 3 }}>

                                <Table>

                                    <TableHead sx={{ ...TableTheadStyle }}>

                                        <TableRow>
                                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, fontWeight: 'bold' }}>Fecha</TableCell>
                                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, fontWeight: 'bold' }}>Referencia</TableCell>
                                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, fontWeight: 'bold' }}>Tipo de juicio</TableCell>
                                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, fontWeight: 'bold' }}>Tipo de acuerdo</TableCell>
                                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, fontWeight: 'bold' }}>Actor(es)</TableCell>
                                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, fontWeight: 'bold' }}>Demandado(s)</TableCell>
                                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, fontWeight: 'bold' }}>Reservado para</TableCell>
                                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, fontWeight: 'bold' }}></TableCell>
                                        </TableRow>

                                    </TableHead>

                                    <TableBody>

                                        {
                                            ( rowsPerPageAcuerdos > 0
                                                ? acuerdos.slice( pageAcuerdos * rowsPerPageAcuerdos, pageAcuerdos * rowsPerPageAcuerdos + rowsPerPageAcuerdos )
                                                : acuerdos
                                            ).map( (acuerdo, index) => (

                                                <TableRow key={ index }>

                                                    <TableCell>
                                                        <Typography variant='subtitle1'>
                                                            { moment( acuerdo.fechaAcuerdo ).format('DD-MM-YYYY') }
                                                        </Typography>
                                                        <Typography variant='caption' color='text.secondary'>
                                                            { moment( acuerdo.fechaAcuerdo ).format('hh:mm a') }
                                                        </Typography>
                                                    </TableCell>

                                                    <TableCell>
                                                        <Typography variant="subtitle1"><strong>{ acuerdo.referencia }</strong></Typography>
                                                    </TableCell>

                                                    <TableCell>{ acuerdo.tipoJuicio }</TableCell>

                                                    <TableCell>
                                                        {
                                                            acuerdo.subTipoAcuerdo
                                                                ?
                                                                <>
                                                                    <Typography variant="subtitle1" fontWeight='bold'>{ acuerdo.tipoAcuerdo }</Typography>
                                                                    <Typography variant="subtitle2" fontWeight='normal' fontSize={ 12 }>({ acuerdo.subTipoAcuerdo })</Typography>
                                                                </>
                                                                :
                                                                <Typography variant="subtitle1" fontWeight='bold'>{ acuerdo.tipoAcuerdo }</Typography>
                                                        }
                                                    </TableCell>

                                                    <TableCell>{ acuerdo.actores?.[0] }</TableCell>

                                                    <TableCell>{ acuerdo.demandados?.[0] }</TableCell>

                                                    <TableCell>{ acuerdo.tipoReservado }</TableCell>

                                                    <TableCell sx={{ textAlign: 'center' }}>
                                                        <Tooltip title='Visualizar acuerdo'>
                                                            <IconButton
                                                                color="primary"
                                                                disabled={ !acuerdo.acuerdo }
                                                                onClick={ () => {

                                                                    setDocumento( acuerdo.acuerdo );
                                                                    setOpenDocumento( true );

                                                                } }
                                                            >
                                                                <AiOutlineFileText fontSize={ 28 } />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </TableCell>

                                                </TableRow>

                                            ))
                                        }

                                        {
                                            acuerdos.length === 0
                                            &&
                                                <TableRow>
                                                    <TableCell colSpan={ 8 } align="center">
                                                        <Typography variant="caption" color='secondary'>No se encontraron registros</Typography>
                                                    </TableCell>
                                                </TableRow>
                                        }

                                    </TableBody>

                                    <TableFooter>

                                        <TableRow>

                                            <TableCell colSpan={ 2 }>
                                                <Typography variant='body2' color='black' sx={{ fontWeight: 'bold' }}>Total de registros: { acuerdos.length }</Typography>
                                            </TableCell>

                                            <TablePagination
                                                rowsPerPageOptions={ [ 5, 10, 15, 25, 50, 75, 100, 150, 200, 500 ] }
                                                colSpan={ 8 }
                                                count={ acuerdos.length }
                                                rowsPerPage={ rowsPerPageAcuerdos }
                                                page={ pageAcuerdos }
                                                onPageChange={ handleChangePageAcuerdos }
                                                onRowsPerPageChange={ handleChangeRowsPerPageAcuerdos }
                                                ActionsComponent={ TablePaginationActions }
                                                labelDisplayedRows={ ({ from, to, count }) => `${ from }-${ to } de ${ count }` }
                                            />

                                        </TableRow>

                                    </TableFooter>

                                </Table>

                            </TableContainer>

                        </Grid>

                    </Grid>

                </DialogContent>

                <DialogActions>

                    <Button color='secondary' onClick={ () => { setOpenAcuerdos( false ); setAcuerdos( [] ); } }>
                        Cerrar
                    </Button>

                </DialogActions>

            </Dialog>

        </Layout>
    );
};
